// C1 Final Sınavı
// Tüm C1 konularını kapsayan kapsamlı final

export const C1_FINAL = {
  'C1-FINAL': {
    id: 'C1-FINAL',
    title: '🏆 C1 Final Sınavı',
    type: 'exam',
    content: {
      timeLimit: 60,
      passingScore: 75,
      questions: [
        // Perfect Tenses
        {
          type: 'multipleChoice',
          question: 'She ___ as a flight attendant for 15 years.',
          options: ['works', 'has been working', 'is working', 'worked'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'By the time we landed, we ___ for 12 hours.',
          options: ['flew', 'had been flying', 'have flown', 'will fly'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'By next month, I ___ 100 international flights.',
          options: ['complete', 'will complete', 'will have completed', 'completed'],
          correctIndex: 2
        },
        // Third Conditional
        {
          type: 'multipleChoice',
          question: 'If I ___ about the delay, I ___ you.',
          options: [
            'knew / would tell',
            'had known / would have told',
            'know / will tell',
            'have known / told'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'I wish I ___ the safety procedures better.',
          options: ['know', 'knew', 'had known', 'will know'],
          correctIndex: 2
        },
        // Advanced Modals
        {
          type: 'multipleChoice',
          question: 'The passenger isn\'t at the gate. He ___ the flight.',
          options: ['must miss', 'must have missed', 'should miss', 'can miss'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'We ___ the captain earlier. It was a mistake not to.',
          options: ['should inform', 'should have informed', 'must inform', 'could inform'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'With this turbulence, we ___ suspend the meal service.',
          options: ['would rather', 'had better', 'might', 'could'],
          correctIndex: 1
        },
        // Complex Sentences
        {
          type: 'multipleChoice',
          question: 'The passenger ___ bag was lost received compensation.',
          options: ['who', 'which', 'whose', 'whom'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: '___ the announcement, the crew prepared for landing.',
          options: ['Hear', 'Hearing', 'Heard', 'To hear'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Never ___ such professional service.',
          options: ['I have experienced', 'have I experienced', 'I experienced', 'did I experienced'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'The weather was severe. ___, the flight was delayed.',
          options: ['But', 'Consequently', 'Although', 'Despite'],
          correctIndex: 1
        },
        // Professional Communication
        {
          type: 'multipleChoice',
          question: 'An angry passenger says "This is unacceptable!" The best response is:',
          options: [
            'Calm down, sir.',
            'I understand your frustration. Let me see what I can do.',
            'That\'s not my problem.',
            'Why are you so angry?'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'The diplomatic way to refuse a request is:',
          options: [
            'No.',
            'I\'m afraid that won\'t be possible.',
            'You can\'t do that.',
            'Absolutely not.'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is appropriate for a PA announcement?',
          options: [
            'Hey folks, we\'re landing soon.',
            'Ladies and gentlemen, we will shortly begin our descent.',
            'Gonna land in a bit.',
            'Landing time!'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default C1_FINAL;
